import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TOKEN_EXPIRATION_TIME = 24 * 60 * 60 * 1000; // 1 dzień w milisekundach

const SessionManager = ({ token, setToken }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenExpiration = () => {
      const savedToken = localStorage.getItem('token');
      const tokenTimestamp = localStorage.getItem('tokenTimestamp');

      if (savedToken && tokenTimestamp) {
        const currentTime = new Date().getTime();
        const tokenAge = currentTime - parseInt(tokenTimestamp, 10);

        if (tokenAge < TOKEN_EXPIRATION_TIME) {
          setToken(savedToken);
          const remainingTime = TOKEN_EXPIRATION_TIME - tokenAge;

          // Automatyczne wylogowanie po upływie pozostałego czasu
          setTimeout(logout, remainingTime);
        } else {
          logout();
        }
      } else {
        logout();
      }
    };

    const logout = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('tokenTimestamp');
      setToken(null);
      navigate('/login');
    };

    checkTokenExpiration();
  }, [navigate, setToken]);

  return null; // Komponent nie renderuje nic na ekranie
};

export default SessionManager;
